<template>
  <div class="contacto-page">
    <!-- Sección de Cotización -->
    <section class="quote-section">
      <h1 class="section-title">Cotiza con Nosotros</h1>
      <FormularioCotizacion />
    </section>

    <!-- Sección de Redes Sociales -->
    <section class="social-media-section">
      <h2 class="section-title">Contáctanos en nuestras redes sociales</h2>
      <div class="social-btns">
        <a
          href="https://www.facebook.com/profile.php?id=100086146676296&sk=about"
          target="_blank"
          class="btn facebook"
        >
          <i class="fab fa-facebook-f"></i>
        </a>
        <a
          href="https://www.instagram.com/rodasep_talca/"
          target="_blank"
          class="btn instagram"
        >
          <i class="fab fa-instagram"></i>
        </a>
        <a
          href="https://wa.me/56989216528"
          target="_blank"
          class="btn whatsapp"
        >
          <i class="fab fa-whatsapp"></i>
        </a>
        <a
          href="https://www.linkedin.com/in/rodasep-e-i-r-l-9573021a7/"
          target="_blank"
          class="btn linkedin"
        >
          <i class="fab fa-linkedin-in"></i>
        </a>
      </div>
    </section>
  </div>
</template>

<script>
import FormularioCotizacion from "@/components/FormularioCotizacion.vue";

export default {
  name: "RodasepContactos",
  components: {
    FormularioCotizacion,
  },
  created() {
    if (!document.getElementById("font-awesome")) {
      const link = document.createElement("link");
      link.id = "font-awesome";
      link.rel = "stylesheet";
      link.href =
        "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css";
      document.head.appendChild(link);
    }
  },
};
</script>

<style scoped>
/* Aquí mantienes el CSS original intacto */
@font-face {
  font-family: "PlayfairDisplay";
  src: url("@/assets/fonts/playfair-display/PlayfairDisplay-Regular.ttf")
    format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "PlayfairDisplay";
  src: url("@/assets/fonts/playfair-display/PlayfairDisplay-Bold.ttf")
    format("truetype");
  font-weight: bold;
  font-style: normal;
}
.contacto-page {
  font-family: "PlayfairDisplay", serif;
  padding: 2rem 0;
  max-width: 1200px;
  margin: 0 auto;
}
.section-title {
  font-size: 2.5rem;
  color: #333;
  text-align: center;
  margin-bottom: 2rem;
  position: relative;
  padding-bottom: 1rem;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.section-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 2px;
  background-color: #00a9e0;
}
.social-media-section {
  padding: 2rem 0;
  text-align: center;
}
.social-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  margin: 40px auto;
}
.btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 90px;
  background-color: #fff;
  border-radius: 28%;
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  transition: all 0.35s cubic-bezier(0.31, -0.105, 0.43, 1.59);
}
.btn:before {
  content: "";
  width: 120%;
  height: 120%;
  position: absolute;
  top: 90%;
  left: -110%;
  transform: rotate(45deg);
  transition: all 0.35s cubic-bezier(0.31, -0.105, 0.43, 1.59);
}
.btn .fab {
  font-size: 38px;
  transform: scale(0.8);
}
.btn.facebook:before {
  background-color: #3b5998;
}
.btn.facebook .fab {
  color: #3b5998;
}
.btn.linkedin:before {
  background-color: #0077b5;
}
.btn.linkedin .fab {
  color: #0077b5;
}
.btn.whatsapp:before {
  background-color: #25d366;
}
.btn.whatsapp .fab {
  color: #25d366;
}
.btn.instagram:before {
  background-color: #e4405f;
}
.btn.instagram .fab {
  color: #e4405f;
}
.btn:hover:before {
  top: -10%;
  left: -10%;
}
.btn:hover .fab {
  color: #fff;
  transform: scale(1);
}
@media (max-width: 768px) {
  .btn {
    width: 70px;
    height: 70px;
  }
  .btn .fab {
    font-size: 28px;
  }
  .section-title {
    font-size: 2rem;
  }
}
@media (max-width: 480px) {
  .btn {
    width: 60px;
    height: 60px;
  }
  .btn .fab {
    font-size: 24px;
  }
  .section-title {
    font-size: 1.75rem;
  }
}
</style>
